"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listedErrors = exports.linkError = exports.componentError = void 0;
var _react = _interopRequireDefault(require("react"));
var __jsx = _react.default.createElement;
/**
 * Returns the error text as a fragment
 * @param {string} linkUrl - url path which is retrieving error
 */
var linkError = function linkError(linkUrl) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return __jsx("div", {
    className: "aem-cmp-error-message"
  }, __jsx("strong", null, "ERROR: Link not displayed due to an unexpected error (", linkUrl, ")"), message && __jsx("p", null, message));
};

/**
 * Returns the error the number of errors as a fragment
 * @param {number} numErrors - number of errors listed
 */
exports.linkError = linkError;
var listedErrors = function listedErrors(numErrors, errorsFound) {
  return __jsx("div", {
    className: "aem-cmp-error-message"
  }, __jsx("strong", null, "ERROR: Link not displayed in ", numErrors, " asset", numErrors === 1 ? '' : 's', " due to lack of title:"), __jsx("ul", null, errorsFound.map(function (link, idx) {
    return __jsx("li", {
      key: idx
    }, link);
  })));
};

/**
 * Returns error message with component name included & possibility to add extra message
 * @param {string} componentName - component name instroduced in text
 * @param {string} message - non mandatory message added
 */
exports.listedErrors = listedErrors;
var componentError = function componentError(componentName) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return __jsx("div", {
    className: "aem-cmp-error-message"
  }, __jsx("strong", null, "ERROR in component ", componentName, ", the component will not be rendered in Publish."), message && __jsx("p", null, message));
};
exports.componentError = componentError;